<div class="route-skeleton">
    <p-skeleton height="12rem"></p-skeleton>
    <p-skeleton *ngFor="let item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14]" height="6rem"></p-skeleton>
</div>
